import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Che cos'è il saldo e stralcio?",
    a: "È un accordo transattivo con il creditore: il debito viene chiuso in via definitiva pagando una cifra inferiore a quella dovuta. Al termine il creditore rilascia una lettera liberatoria e la posizione è estinta, senza debito residuo.",
  },
  {
    q: "Quanto costa la vostra consulenza?",
    a: "La prima consulenza è completamente gratuita e senza impegno. Se decidi di affidarci la pratica, non chiediamo anticipi: riceviamo una percentuale solo al successo, calcolata sul risparmio effettivamente ottenuto e solo ad accordo firmato.",
  },
  {
    q: "Quanto posso risparmiare realisticamente?",
    a: "Nella maggioranza dei casi otteniamo riduzioni tra il 50% e il 70% del dovuto, con punte fino al 90% e oltre nei casi più favorevoli: una nostra cliente ha chiuso un mutuo residuo di 57.000 € pagando 2.500 €. Ogni pratica viene però valutata singolarmente prima di fare qualunque promessa.",
  },
  {
    q: "La mia casa è a rischio pignoramento o già all'asta: potete intervenire?",
    a: "Spesso sì, e prima si interviene meglio è. Analizziamo la procedura in corso, verifichiamo eventuali irregolarità e apriamo una trattativa con il creditore per bloccare o chiudere l'esecuzione. Abbiamo risolto casi anche a ridosso della vendita all'asta.",
  },
  {
    q: "Quanto dura una trattativa?",
    a: "In media da 3 a 9 mesi, a seconda della complessità della posizione e del numero di creditori. Le pratiche con più creditori o con procedure esecutive in corso possono richiedere più tempo: ti aggiorniamo passo dopo passo nella tua area riservata.",
  },
  {
    q: "Quali documenti servono per iniziare?",
    a: "Contratti di finanziamento o mutuo, estratti conto, eventuali decreti ingiuntivi o atti di precetto, comunicazioni dei creditori o delle società di recupero. Se non hai tutto, non preoccuparti: ti aiutiamo noi a ricostruire la documentazione.",
  },
  {
    q: "Trattate anche con banche, finanziarie e società di recupero crediti?",
    a: "Sì. Trattiamo quotidianamente con banche, finanziarie, servicer e società di recupero, oltre a condomini e fornitori. Con la delega firmata gestiamo noi ogni comunicazione: non parli più da solo con nessun creditore.",
  },
  {
    q: "Operate in tutta Italia?",
    a: "Sì, seguiamo clienti in tutta Italia. La maggior parte dell'attività si svolge a distanza (telefono, email, area riservata online) e, quando serve, organizziamo incontri di persona.",
  },
];

export const FaqSection = () => (
  <section className="py-24 md:py-32 bg-white" data-testid="faq-section">
    <div className="container-editorial grid grid-cols-12 gap-8 md:gap-12">
      <div className="col-span-12 md:col-span-4">
        <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#2d6fc4]">— Domande frequenti</p>
        <h2 className="font-serif text-4xl md:text-6xl leading-[0.95] mt-4 text-[#2d6fc4]">
          Dubbi?<br/><em className="italic text-[#2d6fc4]">Risposte chiare.</em>
        </h2>
        <p className="mt-6 text-[#333333] leading-relaxed max-w-sm">
          Le domande che riceviamo più spesso da chi ci contatta per la prima volta. Non trovi la tua? Chiedici direttamente.
        </p>
        <Link to="/prenota" data-testid="faq-cta-booking" className="mt-8 inline-flex items-center gap-2 text-sm text-[#2d6fc4] link-underline pb-0.5">
          Prenota una chiamata gratuita <ArrowUpRight size={14}/>
        </Link>
      </div>
      <div className="col-span-12 md:col-span-8">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} className="border-[#E5E7EB]">
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="font-serif text-lg md:text-xl text-[#2d6fc4] hover:text-[#2d6fc4] hover:no-underline py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-[#333333] leading-relaxed pb-6 max-w-3xl">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
